import styled from "styled-components";

export const ManuContainer = styled.div<{isMobile: boolean}>`
    height: 100%;
    display: flex;
    flex-direction: column;
    width: 310px;
    background: #0F1113;
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    padding-top: ${({isMobile}) => isMobile ? 100 : 14}px;
    // & > div:nth-child(1) {
    //     height: ${({isMobile}) => isMobile ? 'calc(70% - 100px)' : '80%'};
    // }
    // & > div:nth-child(2) {
    //     height: ${({isMobile}) => isMobile ? 'calc(30% - 100px)' : '20%'};
    // }
`
export const HeaderRow = styled.div`
    display: flex;
    height: 60px;
    min-height: 60px;
    align-items: center;
`
export const HeaderTOFIconWrapper = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    width: 160px;
`
export const HeaderCloseIconWrapper = styled.div`
    height: 40px;
    width: 40px;
    margin-left: 40px;
    display: flex;
    align-items: center;
    cursor: pointer;
`

export const MenuRow  = styled.div<{isDone: boolean}>`
    height: 40px;
    margin-top: 20px;
    display: flex;
    width: 100%;
    font-size: 11px;
    //color: #929AA5;
        color: ${({isDone}) => isDone ? 'white': '#929AA5'};
    align-items: center;
    & > span {
        padding-left: 10px;
    }
    user-select: none;
    cursor: ${({isDone}) => isDone ? 'pointer': 'default'};
    //&:hover {
    //    
    //}
`
export const MenuIconWrapper = styled.div<{ isDone: boolean }>`
    display: flex;
    width: 40px;
    height: 40px;
    background: #ffffff05;
    border: 1px solid #ffffff10;
    border-radius: 14px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    & > svg {
        stroke: ${({isDone}) => isDone ? '#ffffff05' : 'inherit'};
    }
`
export const TgWrapper = styled(MenuIconWrapper)`
    & > svg {
        stroke: ${({isDone}) => isDone ? '#23AF91' : '#929AA5'};
    } 
`
export const WebSiteWrapper = styled(MenuIconWrapper)`
    & > svg {
        stroke: ${({isDone}) => isDone ? '#8E7CFF' : '#929AA5'};
    } 
`
export const SupportWrapper = styled(MenuIconWrapper)`
    & > svg {
        stroke: ${({isDone}) => isDone ? '#FFB800' : '#929AA5'};
    } 
`
export const PromoWrapper = styled(MenuIconWrapper)`
    & > svg {
        stroke: ${({isDone}) => isDone ? '#FF5E66' : '#929AA5'};
    } 
`
export const LangWrapper = styled(MenuIconWrapper)`
    & > svg {
        stroke: ${({isDone}) => isDone ? '#23AF91' : '#929AA5'};
    } 
`
export const FeedbackWrapper = styled(MenuIconWrapper)`
    & > svg {
        stroke: ${({isDone}) => isDone ? '#FFB800' : '#929AA5'};
    } 
`
export const TermsWrapper = styled(MenuIconWrapper)`
    & > svg {
        stroke: ${({isDone}) => isDone ? '#FF5E66' : '#929AA5'};
    } 
`

export const MenuFooterContainer = styled.div`
    display: flex;
    //height: 120px;
    border-top: 1px solid #ffffff10;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    & > div {
        display: flex;
        align-items: center;
        height: 30px;
        font-size: 10px;
        color: #929AA540;
        padding-left: 28px;
    }
  
`
export const HeaderAndMianBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 28px;
    min-height: 600px;
    @media(max-height: 750px) {
        min-height: 520px;
    }
`